import React, { useState, useEffect, ChangeEvent, Fragment } from 'react';
import { Input, Button, Row, Col, Form, FormGroup } from 'reactstrap';
import Viewer from 'react-viewer';
import moment from 'moment';
import HorariosAtencionComponent from 'components/Consultorios/HorariosAtencion';
import { FacturacionOOSSConsultorio } from './View';

function CancelationForm(props: any) {
  const { data, setData, gallery, galleryContainer, isLoading, onAccept, onReject } = props;

  const [hasMotivoRechazo, setHasMotivoRechazo] = useState(false);

  useEffect(() => {
    setHasMotivoRechazo(!!data.motivo_rechazo);
  }, [data]);

  const accept = () => {
    if (!onAccept) {
      return;
    }

    onAccept();
  };

  const reject = () => {
    if (!onReject) {
      return;
    }

    onReject();
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { target } = event;

    // Guardamos el nuevo valor
    setData({
      ...data,
      [target.name]: target.value,
    });
  };

  // Los consultorios sin declarar son los cargados a mano, sin consultorio de COKIBA asociado
  const esSinDeclarar = (consultorio: FacturacionOOSSConsultorio) => consultorio.consultorio_id === null;

  const hasConsultoriosDeclarados = data.consultorios.some(
    (consultorio: FacturacionOOSSConsultorio) => !esSinDeclarar(consultorio),
  );
  const hasConsultoriosSinDeclarar = data.consultorios.some(esSinDeclarar);

  return (
    <Form>
      <Row>
        <Col sm={6}>
          <h6 className="heading text-muted mb-4">
            Matriculado
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Matricula</label>
                <p>{ data.matriculate.matricula || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Delegación</label>
                <p>{ data.matriculate.delegacion || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Nombre</label>
                <p>{ data.matriculate.nombre || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Apellido</label>
                <p>{ data.matriculate.apellido || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Datos Facturación OOSS
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Alta en OOSS</label>
                <p>{ data.prestador_os ? 'Sí' : 'No' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Alta en IOMA</label>
                <p>{ data.prestador_ioma ? 'Sí' : 'No' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Número RNP</label>
                <p>{ data.numero_rnp || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Vencimiento RNP</label>
                <p>{ moment(data.vencimiento_rnp, 'YYYY-MM-DD').format('DD/MM/YYYY') || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Condición IVA</label>
                <p>{ data.condicion_iva || '' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Sucursal Bancaria</label>
                <p>{ `${data.nro_sucursal_banco} - ${data.nombre_sucursal_banco}` || '' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Atención a Domicilio
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Atiende a Domicilio OOSS</label>
                <p>{ data.atencion_domiciliario ? 'Sí' : 'No' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Atiende a Domicilio IOMA</label>
                <p>{ data.atencion_domiciliario_ioma ? 'Sí' : 'No' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Partido</label>
                <p>
                  {
                    (data.atencion_domiciliario || data.atencion_domiciliario_ioma) && data.partido_name
                      ? data.partido_name
                      : '-'
                  }
                </p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Localidad</label>
                <p>
                  {
                    (data.atencion_domiciliario || data.atencion_domiciliario_ioma) && data.localidad_name
                      ? data.localidad_name
                      : '-'
                  }
                </p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Teléfono Domicilio</label>
                <p>
                  {
                    (data.atencion_domiciliario || data.atencion_domiciliario_ioma) &&
                    data.prefijo_telefono_domicilio && data.numero_telefono_domicilio
                      ? `${data.prefijo_telefono_domicilio} ${data.numero_telefono_domicilio}`
                      : '-'
                  }
                </p>
              </FormGroup>
            </Col>
          </Row>
          { hasConsultoriosDeclarados
            ?
              <>
                <hr className="my-4" />
                <h6 className="heading text-muted mb-4">
                  Consultorios
                </h6>
              </>
            : null
          }
          {
            data.consultorios.map((consultorio: FacturacionOOSSConsultorio) => {
              return (!esSinDeclarar(consultorio)
                ?
                  <Fragment key={consultorio.consultorio_id}>
                    <Row>
                      <Col sm={6}>
                        <FormGroup>
                          <label className='form-control-label'>Consultorio</label>
                          <p>
                            { consultorio.calle }&nbsp;
                            { !!consultorio.numero && consultorio.numero != 'null'
                              ? 'Nro. ' + consultorio.numero
                              : ''
                            }
                            { consultorio.piso}{consultorio.departamento } -&nbsp;
                            { consultorio.localidad_name },&nbsp;
                            { consultorio.partido_name }
                          </p>
                        </FormGroup>
                      </Col>
                      { consultorio.numero_resolucion
                        ?
                          <Col sm={6}>
                            <FormGroup>
                              <label className='form-control-label'>Número Resolución</label>
                              <p>{ consultorio.numero_resolucion || '-' }</p>
                            </FormGroup>
                          </Col>
                        : null
                      }
                    </Row>
                  </Fragment>
                : null
              );
            })
          }
          { hasConsultoriosSinDeclarar
            ?
              <>
                <hr className="my-4" />
                <h6 className="heading text-muted mb-4">
                  Consultorio sin declarar
                </h6>
              </>
            : null
          }
          {
            data.consultorios.map((consultorio: FacturacionOOSSConsultorio) => {
              return (esSinDeclarar(consultorio)
                ?
                  <Fragment key={consultorio.consultorio_id}>
                    <Row>
                      <Col sm={6}>
                        <FormGroup>
                          <label className='form-control-label'>Partido</label>
                          <p>{ consultorio.partido_name || '-' }</p>
                        </FormGroup>
                      </Col>
                      <Col sm={6}>
                        <FormGroup>
                          <label className='form-control-label'>Localidad</label>
                          <p>{ consultorio.localidad_name || '-' }</p>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6}>
                        <FormGroup>
                          <label className='form-control-label'>Calle</label>
                          <p>{ consultorio.calle || '-' }</p>
                        </FormGroup>
                      </Col>
                      <Col sm={6}>
                        <FormGroup>
                          <label className='form-control-label'>Número</label>
                          <p>{ consultorio.numero || '-' }</p>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6}>
                        <FormGroup>
                          <label className='form-control-label'>Piso</label>
                          <p>{ consultorio.piso || '-' }</p>
                        </FormGroup>
                      </Col>
                      <Col sm={6}>
                        <FormGroup>
                          <label className='form-control-label'>Departamento</label>
                          <p>{ consultorio.departamento || '-' }</p>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <FormGroup>
                          <label className='form-control-label'>Código Postal</label>
                          <p>{ consultorio.codigo_postal || '-' }</p>
                        </FormGroup>
                      </Col>
                    </Row>
                    { consultorio.horarios_atencion
                      ?
                        <Row>
                          <Col sm={12}>
                            <FormGroup>
                              <label className='form-control-label'>Días y horarios de atención</label>
                              <HorariosAtencionComponent
                                value={consultorio.horarios_atencion}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      : null
                    }
                  </Fragment>
                : null
              );
            })
          }
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Datos adicionales
          </h6>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>DGR del Matriculado</label>
                {
                  data.state_id == 2 && !!data.dgr_matriculado
                    ?
                      <p>{ data.dgr_matriculado }</p>
                    :
                      <Input
                        id="dgr_matriculado"
                        name="dgr_matriculado"
                        type="text"
                        value={data.dgr_matriculado ?? ''}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                }
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Rechazo
          </h6>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>Motivo de rechazo</label>
                {
                  data.state_id == 3 && hasMotivoRechazo
                    ?
                      <p>{ data.motivo_rechazo }</p>
                    :
                      <Input
                        id="motivo_rechazo"
                        name="motivo_rechazo"
                        type="textarea"
                        value={data.motivo_rechazo ?? ''}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                }
              </FormGroup>
            </Col>
          </Row>
        </Col>
        <Col sm={6}>
          <div className="">
            <label className="form-control-label">Adjuntos</label>
            <div
              id="gallery-container"
              style={{ height: '80vh' }}
              ref={galleryContainer}
            >
              {
                Array.isArray(gallery) &&
                gallery.length &&
                galleryContainer.current
                  ?
                    <Viewer
                      container={galleryContainer.current}
                      noClose={true}
                      visible={true}
                      disableMouseZoom={true}
                      downloadable={true}
                      disableKeyboardSupport={true}
                      zoomSpeed={0.5}
                      downloadInNewWindow={true}
                      noImgDetails={true}
                      scalable={false}
                      showTotal={false}
                      defaultScale={1.25}
                      defaultImg={{
                        src: require('../../../assets/img/404.png'),
                      }}
                      images={gallery}
                    />
                  : null
              }
            </div>
          </div>
        </Col>
      </Row>
      {
        onAccept || onReject
          ? <Row>
              <hr className="my-4" />
              <Col className="text-center">
                <Button color="danger" onClick={ reject } disabled={ isLoading }>Rechazar</Button>
                <Button color="success" onClick={ accept } disabled={ isLoading }>Aceptar</Button>
              </Col>
            </Row>
          : null
      }
    </Form>
  );
}

export default CancelationForm;
